import { COMMON_CONSTS } from '../common/common.consts'

export const ANALYTICS_CONSTS = {
  moduleName: 'epb-analytics',

  getters: {
    data: 'data',
    selectedId: 'selectedId',
  },
  actions: {
    ...COMMON_CONSTS.actions,
    loadDistData: 'loadDistData',
    loadPivotData: 'loadPivotData',
    loadSessionsData: 'loadSessionsData',
    loadQueriesData: 'loadQueriesData',
    loadRelatedData: 'loadRelatedData',
    loadSearchData: 'loadSearchData',

    setSelectedId: 'setSelectedId',

    fetchStatsReport: 'fetchStatsReport',
  },
  mutations: {
    ...COMMON_CONSTS.mutations,
    setDistData: 'setDistData',
    setPivotData: 'setPivotData',
    setSessionsData: 'setSessionsData',
    setQueriesData: 'setQueriesData',
    setRelatedData: 'setRelatedData',
    setSearchData: 'setSearchData',

    setSelectedId: 'setSelectedId',
  },
}
